import {AnalysisGraphQL} from 'analysis-tool/AnalysisTypes';

export enum AnalysisRightSidebarItemType {
  EDIT_VIEW = 'EDIT_VIEW',
}

export interface AnalysisRightSidebarItem {
  type: AnalysisRightSidebarItemType.EDIT_VIEW;
  stepId: string;
}

// Convenience type utility for this file to access a subset of the members of AnalysisRightSidebarItem based on
// the type key.
export type GenericAnalysisRightSidebarItem<T extends AnalysisRightSidebarItemType> = Extract<
  AnalysisRightSidebarItem,
  {type: T}
>;

export interface RightSidebarComponentProps<T extends AnalysisRightSidebarItemType> {
  analysis: AnalysisGraphQL;
  selectedRightSidebarItem: GenericAnalysisRightSidebarItem<T>;
  onChangeSelectedRightSidebarItem: (
    newSelectedRightSidebarItem: GenericAnalysisRightSidebarItem<T> | null
  ) => void;
  clientStateId: string;
}
